import { React } from 'react';
import { NavDropdown } from 'react-bootstrap';
// import { FiEdit } from 'react-icons/fi';

export default function SideBar() {
  return (
    <div id="dropdown-edit" className="dropdown responsive">
      <NavDropdown
        className="navlink-edit"
        title="Editar"
        id="responsive-nav-dropdown"
      >
        <NavDropdown.Item tabIndex="0" href="/backoffice#editar-imagem">
          Imagem Principal
        </NavDropdown.Item>
        <NavDropdown.Item tabIndex="0" href="/backoffice#editar-sobre">
          Sobre Nós
        </NavDropdown.Item>
        <NavDropdown.Item tabIndex="0" href="/backoffice#editar-serviços">
          Serviços
        </NavDropdown.Item>
        <NavDropdown.Item tabIndex="0" href="/backoffice#editar-notícias">
          Notícias
        </NavDropdown.Item>
        <NavDropdown.Item tabIndex="0" href="/backoffice#editar-contactos">
          Contactos
        </NavDropdown.Item>
        <NavDropdown.Item tabIndex="0" href="/backoffice#editar-logo">
          Logótipo
        </NavDropdown.Item>
        <NavDropdown.Item tabIndex="0" href="/backoffice#editar-password">
          Palavra-Passe
        </NavDropdown.Item>
        <NavDropdown.Item tabIndex="0" href="/backoffice#logout">
          Logout
        </NavDropdown.Item>
      </NavDropdown>
    </div>
  );
}
